<div>
  <span *ngIf="ilClass.availableSeats; else waitlist">{{ i18nAvailableSeats }}</span>
  <ng-template #waitlist>
    <p-message severity="info" [text]="'il-class-availability.waitlist-enabled' | translate"></p-message>
  </ng-template>
</div>
